import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeletePropertyPriceMutation, useGetPropertyPriceByIdQuery } from "../../../services/bClientApi"

export default function DeletePropertyPricePage() {

    const [deletePropertyPrice, {
        error: deleteError,
        isLoading: deleteLoading,
    }] = useDeletePropertyPriceMutation()

    const { propertyPriceId = '' } = useParams()
    const dispatch = useAppDispatch()
    const [deleteClicked, setDeleteClicked] = useState(false)

    const {
        data,
        error,
        isLoading,
      } = useGetPropertyPriceByIdQuery(propertyPriceId, { skip: !propertyPriceId || deleteClicked })
      const propertyPriceData = data || {}


    const propertyPriceDeleteFn = async () => {
        if (propertyPriceId) {
            const deleteValue = await deletePropertyPrice(propertyPriceId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo(`/property-prices/`))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete PropertyPrice Page</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {deleteError && (<>{JSON.stringify(deleteError)}<br /></>)}

                    {propertyPriceId && propertyPriceData && !isLoading && (
                        <div className="propertyPrice-info">
                            {JSON.stringify(propertyPriceData)}

                            <Stack gap={3}>
                                <div>Are you sure you want to delete PropertyPrice: {propertyPriceId}</div>
                                <div>
                                    <Button variant={'warning'} onClick={() => setDeleteClicked(true)}>Delete PropertyPrice</Button>
                                </div>
                                {deleteClicked && (
                                    <div>
                                        Once you delete this propertyPrice it will be gone forever. <br />
                                        <Button variant={'danger'} disabled={deleteLoading} onClick={() => {
                                            propertyPriceDeleteFn()
                                        }}> Confirm Delete PropertyPrice </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
